import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  CompaniesApiFactory,
  UpdateCompanyCommand,
} from "../../../api/api-types";
import { queryKeys } from "../../../../constants/queryKeys";

export default function useUpdateCompany() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpdateCompanyCommand) =>
      CompaniesApiFactory()
        .updateCompany(data)
        .then((res) => res.data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [queryKeys.companies.paginatedCompanies],
      });
    },
  });
}